import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractStatusCreateForm from "./create";
import ContractStatusEditForm from "./edit";
import {
  getContractStatusDetails,
  getContractStatuses,
} from "src/store/contract-status/saga";
import {
  ContractStatusDetailDto,
  ContractStatusDto,
} from "src/store/contract-status/type";
const ContractStatusesPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ContractStatusDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ContractStatusDetailDto>();
  const columns = [
    {
      text: t("Contract.Status.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.Status.PageTitle")}
        metaTag={t("Contract.Status.MetaTag")}
        gridProps={{
          addTitle: t("Contract.Status.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getContractStatuses,
          //  onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getContractStatusDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          // deleteButton: {
          //   text: (id, data: SectorDto) =>
          //     t("Contract.Status.DeleteQA", {
          //       name: data.Name,
          //     }),
          //   action: deleteSectorSaga,
          //   onClick: (id, data) => setShowEdit(data),
          // },
        }}
      />
      <ContractStatusCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getContractStatuses,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractStatusEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getContractStatuses,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractStatusesPage;
